import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/config";

const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "About", href: "#about" },
  { label: "Pricing", href: "#pricing" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-[#E1E8E9]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="#top" data-testid="header-logo" className="flex items-center">
            <img
              src="/logo.webp"
              alt="Virtual Bookkeeping"
              className="h-12 w-auto"
            />
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm font-medium text-[#10242B] hover:text-[#0DA2AD] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-5">
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="header-phone"
              className="flex items-center gap-2 text-sm font-semibold text-[#10242B] hover:text-[#0DA2AD] transition-colors"
            >
              <Phone size={16} strokeWidth={2.4} />
              {PHONE_DISPLAY}
            </a>
            <a
              href="#book"
              data-testid="header-cta"
              className="bg-[#E8791F] text-white text-sm font-semibold px-5 py-3 rounded-md hover:bg-[#CE6410] transition-colors"
            >
              Book a Free Consultation
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-[#10242B]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-b border-[#E1E8E9] px-6 py-6 space-y-4"
        >
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-base font-medium text-[#10242B]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${PHONE_TEL}`}
            className="flex items-center gap-2 text-base font-semibold text-[#10242B]"
          >
            <Phone size={18} /> {PHONE_DISPLAY}
          </a>
          <a
            href="#book"
            onClick={() => setOpen(false)}
            className="block text-center bg-[#E8791F] text-white font-semibold px-5 py-3 rounded-md"
          >
            Book a Free Consultation
          </a>
        </div>
      )}
    </header>
  );
}
